<template>
  <div>
    <div
      v-if="!isManager"
      class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3"
    >
      <h4 class="mb-0">
        Vacation Tracker
      </h4>
      <div class="d-flex gap-2">
        <staff-vacation-request-button
          ref="requestLeaveBtn"
          :staff-id="staffId"
          @update-table="updateTable"
        />
        <staff-holiday-work-request-button
          ref="holidayWorkBtn"
          :staff-id="staffId"
          @update-table="updateTable"
        />
      </div>
    </div>

    <template v-if="!isManager">
      <vacation-dashboard-summary :staff-id="staffId" />
      <!-- <vacation-pending-requests
        :staff-id="staffId"
        @update="updateTable"
      >
        <template #empty-action>
          <staff-vacation-request-button
            :staff-id="staffId"
            class="btn btn-primary btn-sm"
            @update-table="updateTable"
          />
        </template>
      </vacation-pending-requests> -->

      <holiday-work-requests-list
        :staff-id="staffId"
        :is-super-admin="isSuperAdmin"
        @update="updateTable"
        @open-form="openHolidayWorkForm"
      />

      <vacation-calendar
        v-if="showCalendar"
        :staff-id="staffId"
        @request-leave="openRequestModal"
      />
      <upcoming-holidays v-if="showHolidays" />
    </template>

    <holiday-work-requests-list
      v-if="isManager && isSuperAdmin"
      :staff-id="staffId"
      :is-super-admin="isSuperAdmin"
      @update="updateTable"
    />

    <staff-vacation-tracker-table
      :key="`vacation-table-${updateKey}`"
      :staff-id="staffId"
      leave-type="vacation"
    />
    <staff-vacation-tracker-table
      :key="`sick-leave-table-${updateKey}`"
      :staff-id="staffId"
      leave-type="sick_leave"
    />
  </div>
</template>

<script>
export default {
    name: "StaffVacationTracker",
    props: {
        staffId: {
            type: Number,
            required: true,
        },
        managerId: {
            type: Number,
            required: false,
            default: null,
        },
        isSuperAdmin: {
            type: Boolean,
            required: false,
            default: false,
        },
        leaveType: {
            type: String,
            required: false,
            default: "vacation",
        },
    },
    data() {
        return {
            updateKey: 0,
            showCalendar: false,
            showHolidays: false,
        };
    },
    computed: {
        isManager() {
            return this.managerId !== null;
        },
    },
    mounted() {
        this.$store.dispatch("vacation/getStaffVacations", { staffId: this.staffId, leaveType: "vacation" });
        this.$store.dispatch("vacation/getStaffVacations", { staffId: this.staffId, leaveType: "sick_leave" });
        this.$store.dispatch("vacation/getHolidayWorkRequests", { staffId: this.staffId }).catch(() => {});
    },
    methods: {
        openRequestModal(day) {
            const date = day?.date ?? day;
            this.$refs.requestLeaveBtn?.showRequestModal?.(date);
        },
        openHolidayWorkForm() {
            this.$refs.holidayWorkBtn?.showRequestModal?.();
        },
        updateTable() {
            this.updateKey++;
            this.$store.dispatch("vacation/getStaffVacations", { staffId: this.staffId, leaveType: "vacation" });
            this.$store.dispatch("vacation/getStaffVacations", { staffId: this.staffId, leaveType: "sick_leave" });
            this.$store.dispatch("vacation/getHolidayWorkRequests", { staffId: this.staffId }).catch(() => {});
        },
    },
};
</script>
